/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as AppLayoutRouteImport } from './pages/_app/layout'
import { Route as AuthSairRouteImport } from './pages/_auth/sair'
import { Route as AuthEntrarRouteImport } from './pages/_auth/entrar'
import { Route as AuthAuthRouteImport } from './pages/_auth/auth'
import { Route as AppDashboardLayoutRouteImport } from './pages/_app/_dashboard/layout'
import { Route as AppDashboardIndexRouteImport } from './pages/_app/_dashboard/index'
import { Route as AppDashboardExplorarRouteImport } from './pages/_app/_dashboard/explorar'
import { Route as AppDashboardCentralRouteImport } from './pages/_app/_dashboard/central'
import { Route as AppStudioIdLayoutRouteImport } from './pages/_app/studio/$id/layout'
import { Route as AppDashboardProjetosLayoutRouteImport } from './pages/_app/_dashboard/projetos/layout'
import { Route as AppStudioIdIndexRouteImport } from './pages/_app/studio/$id/index'
import { Route as AppDashboardProjetosIndexRouteImport } from './pages/_app/_dashboard/projetos/index'
import { Route as AppStudioIdPublicarRouteImport } from './pages/_app/studio/$id/publicar'
import { Route as AppDashboardProjetosProjetoLayoutRouteImport } from './pages/_app/_dashboard/projetos/$projeto/layout'
import { Route as AppDashboardProjetosProjetoIndexRouteImport } from './pages/_app/_dashboard/projetos/$projeto/index'
import { Route as AppDashboardProjetosProjetoMembrosRouteImport } from './pages/_app/_dashboard/projetos/$projeto/membros'
import { Route as AppDashboardProjetosProjetoPodcastPodcastLayoutRouteImport } from './pages/_app/_dashboard/projetos/$projeto/podcast/$podcast/layout'
import { Route as AppDashboardProjetosProjetoPodcastPodcastIndexRouteImport } from './pages/_app/_dashboard/projetos/$projeto/podcast/$podcast/index'

const AppLayoutRoute = AppLayoutRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSairRoute = AuthSairRouteImport.update({
  id: '/_auth/sair',
  path: '/sair',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthEntrarRoute = AuthEntrarRouteImport.update({
  id: '/_auth/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAuthRoute = AuthAuthRouteImport.update({
  id: '/_auth/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDashboardLayoutRoute = AppDashboardLayoutRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDashboardLayoutRoute,
} as any)
const AppDashboardExplorarRoute = AppDashboardExplorarRouteImport.update({
  id: '/explorar',
  path: '/explorar',
  getParentRoute: () => AppDashboardLayoutRoute,
} as any)
const AppDashboardCentralRoute = AppDashboardCentralRouteImport.update({
  id: '/central',
  path: '/central',
  getParentRoute: () => AppDashboardLayoutRoute,
} as any)
const AppStudioIdLayoutRoute = AppStudioIdLayoutRouteImport.update({
  id: '/studio/$id',
  path: '/studio/$id',
  getParentRoute: () => AppLayoutRoute,
} as any)
const AppDashboardProjetosLayoutRoute =
  AppDashboardProjetosLayoutRouteImport.update({
    id: '/projetos',
    path: '/projetos',
    getParentRoute: () => AppDashboardLayoutRoute,
  } as any)
const AppStudioIdIndexRoute = AppStudioIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStudioIdLayoutRoute,
} as any)
const AppDashboardProjetosIndexRoute =
  AppDashboardProjetosIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardProjetosLayoutRoute,
  } as any)
const AppStudioIdPublicarRoute = AppStudioIdPublicarRouteImport.update({
  id: '/publicar',
  path: '/publicar',
  getParentRoute: () => AppStudioIdLayoutRoute,
} as any)
const AppDashboardProjetosProjetoLayoutRoute =
  AppDashboardProjetosProjetoLayoutRouteImport.update({
    id: '/$projeto',
    path: '/$projeto',
    getParentRoute: () => AppDashboardProjetosLayoutRoute,
  } as any)
const AppDashboardProjetosProjetoIndexRoute =
  AppDashboardProjetosProjetoIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardProjetosProjetoLayoutRoute,
  } as any)
const AppDashboardProjetosProjetoMembrosRoute =
  AppDashboardProjetosProjetoMembrosRouteImport.update({
    id: '/membros',
    path: '/membros',
    getParentRoute: () => AppDashboardProjetosProjetoLayoutRoute,
  } as any)
const AppDashboardProjetosProjetoPodcastPodcastLayoutRoute =
  AppDashboardProjetosProjetoPodcastPodcastLayoutRouteImport.update({
    id: '/podcast/$podcast',
    path: '/podcast/$podcast',
    getParentRoute: () => AppDashboardProjetosProjetoLayoutRoute,
  } as any)
const AppDashboardProjetosProjetoPodcastPodcastIndexRoute =
  AppDashboardProjetosProjetoPodcastPodcastIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDashboardProjetosProjetoPodcastPodcastLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthAuthRoute
  '/entrar': typeof AuthEntrarRoute
  '/sair': typeof AuthSairRoute
  '/projetos': typeof AppDashboardProjetosLayoutRouteWithChildren
  '/studio/$id': typeof AppStudioIdLayoutRouteWithChildren
  '/central': typeof AppDashboardCentralRoute
  '/explorar': typeof AppDashboardExplorarRoute
  '/': typeof AppDashboardIndexRoute
  '/projetos/$projeto': typeof AppDashboardProjetosProjetoLayoutRouteWithChildren
  '/studio/$id/publicar': typeof AppStudioIdPublicarRoute
  '/projetos/': typeof AppDashboardProjetosIndexRoute
  '/studio/$id/': typeof AppStudioIdIndexRoute
  '/projetos/$projeto/membros': typeof AppDashboardProjetosProjetoMembrosRoute
  '/projetos/$projeto/': typeof AppDashboardProjetosProjetoIndexRoute
  '/projetos/$projeto/podcast/$podcast': typeof AppDashboardProjetosProjetoPodcastPodcastLayoutRouteWithChildren
  '/projetos/$projeto/podcast/$podcast/': typeof AppDashboardProjetosProjetoPodcastPodcastIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthAuthRoute
  '/entrar': typeof AuthEntrarRoute
  '/sair': typeof AuthSairRoute
  '/central': typeof AppDashboardCentralRoute
  '/explorar': typeof AppDashboardExplorarRoute
  '/': typeof AppDashboardIndexRoute
  '/studio/$id/publicar': typeof AppStudioIdPublicarRoute
  '/projetos': typeof AppDashboardProjetosIndexRoute
  '/studio/$id': typeof AppStudioIdIndexRoute
  '/projetos/$projeto/membros': typeof AppDashboardProjetosProjetoMembrosRoute
  '/projetos/$projeto': typeof AppDashboardProjetosProjetoIndexRoute
  '/projetos/$projeto/podcast/$podcast': typeof AppDashboardProjetosProjetoPodcastPodcastIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppLayoutRouteWithChildren
  '/_app/_dashboard': typeof AppDashboardLayoutRouteWithChildren
  '/_auth/auth': typeof AuthAuthRoute
  '/_auth/entrar': typeof AuthEntrarRoute
  '/_auth/sair': typeof AuthSairRoute
  '/_app/_dashboard/projetos': typeof AppDashboardProjetosLayoutRouteWithChildren
  '/_app/studio/$id': typeof AppStudioIdLayoutRouteWithChildren
  '/_app/_dashboard/central': typeof AppDashboardCentralRoute
  '/_app/_dashboard/explorar': typeof AppDashboardExplorarRoute
  '/_app/_dashboard/': typeof AppDashboardIndexRoute
  '/_app/_dashboard/projetos/$projeto': typeof AppDashboardProjetosProjetoLayoutRouteWithChildren
  '/_app/studio/$id/publicar': typeof AppStudioIdPublicarRoute
  '/_app/_dashboard/projetos/': typeof AppDashboardProjetosIndexRoute
  '/_app/studio/$id/': typeof AppStudioIdIndexRoute
  '/_app/_dashboard/projetos/$projeto/membros': typeof AppDashboardProjetosProjetoMembrosRoute
  '/_app/_dashboard/projetos/$projeto/': typeof AppDashboardProjetosProjetoIndexRoute
  '/_app/_dashboard/projetos/$projeto/podcast/$podcast': typeof AppDashboardProjetosProjetoPodcastPodcastLayoutRouteWithChildren
  '/_app/_dashboard/projetos/$projeto/podcast/$podcast/': typeof AppDashboardProjetosProjetoPodcastPodcastIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/entrar'
    | '/sair'
    | '/projetos'
    | '/studio/$id'
    | '/central'
    | '/explorar'
    | '/'
    | '/projetos/$projeto'
    | '/studio/$id/publicar'
    | '/projetos/'
    | '/studio/$id/'
    | '/projetos/$projeto/membros'
    | '/projetos/$projeto/'
    | '/projetos/$projeto/podcast/$podcast'
    | '/projetos/$projeto/podcast/$podcast/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/entrar'
    | '/sair'
    | '/central'
    | '/explorar'
    | '/'
    | '/studio/$id/publicar'
    | '/projetos'
    | '/studio/$id'
    | '/projetos/$projeto/membros'
    | '/projetos/$projeto'
    | '/projetos/$projeto/podcast/$podcast'
  id:
    | '__root__'
    | '/_app'
    | '/_app/_dashboard'
    | '/_auth/auth'
    | '/_auth/entrar'
    | '/_auth/sair'
    | '/_app/_dashboard/projetos'
    | '/_app/studio/$id'
    | '/_app/_dashboard/central'
    | '/_app/_dashboard/explorar'
    | '/_app/_dashboard/'
    | '/_app/_dashboard/projetos/$projeto'
    | '/_app/studio/$id/publicar'
    | '/_app/_dashboard/projetos/'
    | '/_app/studio/$id/'
    | '/_app/_dashboard/projetos/$projeto/membros'
    | '/_app/_dashboard/projetos/$projeto/'
    | '/_app/_dashboard/projetos/$projeto/podcast/$podcast'
    | '/_app/_dashboard/projetos/$projeto/podcast/$podcast/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppLayoutRoute: typeof AppLayoutRouteWithChildren
  AuthAuthRoute: typeof AuthAuthRoute
  AuthEntrarRoute: typeof AuthEntrarRoute
  AuthSairRoute: typeof AuthSairRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/sair': {
      id: '/_auth/sair'
      path: '/sair'
      fullPath: '/sair'
      preLoaderRoute: typeof AuthSairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/entrar': {
      id: '/_auth/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof AuthEntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/auth': {
      id: '/_auth/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_dashboard': {
      id: '/_app/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppDashboardLayoutRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/_app/_dashboard/': {
      id: '/_app/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppDashboardLayoutRoute
    }
    '/_app/_dashboard/explorar': {
      id: '/_app/_dashboard/explorar'
      path: '/explorar'
      fullPath: '/explorar'
      preLoaderRoute: typeof AppDashboardExplorarRouteImport
      parentRoute: typeof AppDashboardLayoutRoute
    }
    '/_app/_dashboard/central': {
      id: '/_app/_dashboard/central'
      path: '/central'
      fullPath: '/central'
      preLoaderRoute: typeof AppDashboardCentralRouteImport
      parentRoute: typeof AppDashboardLayoutRoute
    }
    '/_app/studio/$id': {
      id: '/_app/studio/$id'
      path: '/studio/$id'
      fullPath: '/studio/$id'
      preLoaderRoute: typeof AppStudioIdLayoutRouteImport
      parentRoute: typeof AppLayoutRoute
    }
    '/_app/_dashboard/projetos': {
      id: '/_app/_dashboard/projetos'
      path: '/projetos'
      fullPath: '/projetos'
      preLoaderRoute: typeof AppDashboardProjetosLayoutRouteImport
      parentRoute: typeof AppDashboardLayoutRoute
    }
    '/_app/studio/$id/': {
      id: '/_app/studio/$id/'
      path: '/'
      fullPath: '/studio/$id/'
      preLoaderRoute: typeof AppStudioIdIndexRouteImport
      parentRoute: typeof AppStudioIdLayoutRoute
    }
    '/_app/_dashboard/projetos/': {
      id: '/_app/_dashboard/projetos/'
      path: '/'
      fullPath: '/projetos/'
      preLoaderRoute: typeof AppDashboardProjetosIndexRouteImport
      parentRoute: typeof AppDashboardProjetosLayoutRoute
    }
    '/_app/studio/$id/publicar': {
      id: '/_app/studio/$id/publicar'
      path: '/publicar'
      fullPath: '/studio/$id/publicar'
      preLoaderRoute: typeof AppStudioIdPublicarRouteImport
      parentRoute: typeof AppStudioIdLayoutRoute
    }
    '/_app/_dashboard/projetos/$projeto': {
      id: '/_app/_dashboard/projetos/$projeto'
      path: '/$projeto'
      fullPath: '/projetos/$projeto'
      preLoaderRoute: typeof AppDashboardProjetosProjetoLayoutRouteImport
      parentRoute: typeof AppDashboardProjetosLayoutRoute
    }
    '/_app/_dashboard/projetos/$projeto/': {
      id: '/_app/_dashboard/projetos/$projeto/'
      path: '/'
      fullPath: '/projetos/$projeto/'
      preLoaderRoute: typeof AppDashboardProjetosProjetoIndexRouteImport
      parentRoute: typeof AppDashboardProjetosProjetoLayoutRoute
    }
    '/_app/_dashboard/projetos/$projeto/membros': {
      id: '/_app/_dashboard/projetos/$projeto/membros'
      path: '/membros'
      fullPath: '/projetos/$projeto/membros'
      preLoaderRoute: typeof AppDashboardProjetosProjetoMembrosRouteImport
      parentRoute: typeof AppDashboardProjetosProjetoLayoutRoute
    }
    '/_app/_dashboard/projetos/$projeto/podcast/$podcast': {
      id: '/_app/_dashboard/projetos/$projeto/podcast/$podcast'
      path: '/podcast/$podcast'
      fullPath: '/projetos/$projeto/podcast/$podcast'
      preLoaderRoute: typeof AppDashboardProjetosProjetoPodcastPodcastLayoutRouteImport
      parentRoute: typeof AppDashboardProjetosProjetoLayoutRoute
    }
    '/_app/_dashboard/projetos/$projeto/podcast/$podcast/': {
      id: '/_app/_dashboard/projetos/$projeto/podcast/$podcast/'
      path: '/'
      fullPath: '/projetos/$projeto/podcast/$podcast/'
      preLoaderRoute: typeof AppDashboardProjetosProjetoPodcastPodcastIndexRouteImport
      parentRoute: typeof AppDashboardProjetosProjetoPodcastPodcastLayoutRoute
    }
  }
}

interface AppDashboardProjetosProjetoPodcastPodcastLayoutRouteChildren {
  AppDashboardProjetosProjetoPodcastPodcastIndexRoute: typeof AppDashboardProjetosProjetoPodcastPodcastIndexRoute
}

const AppDashboardProjetosProjetoPodcastPodcastLayoutRouteChildren: AppDashboardProjetosProjetoPodcastPodcastLayoutRouteChildren =
  {
    AppDashboardProjetosProjetoPodcastPodcastIndexRoute:
      AppDashboardProjetosProjetoPodcastPodcastIndexRoute,
  }

const AppDashboardProjetosProjetoPodcastPodcastLayoutRouteWithChildren =
  AppDashboardProjetosProjetoPodcastPodcastLayoutRoute._addFileChildren(
    AppDashboardProjetosProjetoPodcastPodcastLayoutRouteChildren,
  )

interface AppDashboardProjetosProjetoLayoutRouteChildren {
  AppDashboardProjetosProjetoMembrosRoute: typeof AppDashboardProjetosProjetoMembrosRoute
  AppDashboardProjetosProjetoIndexRoute: typeof AppDashboardProjetosProjetoIndexRoute
  AppDashboardProjetosProjetoPodcastPodcastLayoutRoute: typeof AppDashboardProjetosProjetoPodcastPodcastLayoutRouteWithChildren
}

const AppDashboardProjetosProjetoLayoutRouteChildren: AppDashboardProjetosProjetoLayoutRouteChildren =
  {
    AppDashboardProjetosProjetoMembrosRoute:
      AppDashboardProjetosProjetoMembrosRoute,
    AppDashboardProjetosProjetoIndexRoute:
      AppDashboardProjetosProjetoIndexRoute,
    AppDashboardProjetosProjetoPodcastPodcastLayoutRoute:
      AppDashboardProjetosProjetoPodcastPodcastLayoutRouteWithChildren,
  }

const AppDashboardProjetosProjetoLayoutRouteWithChildren =
  AppDashboardProjetosProjetoLayoutRoute._addFileChildren(
    AppDashboardProjetosProjetoLayoutRouteChildren,
  )

interface AppDashboardProjetosLayoutRouteChildren {
  AppDashboardProjetosProjetoLayoutRoute: typeof AppDashboardProjetosProjetoLayoutRouteWithChildren
  AppDashboardProjetosIndexRoute: typeof AppDashboardProjetosIndexRoute
}

const AppDashboardProjetosLayoutRouteChildren: AppDashboardProjetosLayoutRouteChildren =
  {
    AppDashboardProjetosProjetoLayoutRoute:
      AppDashboardProjetosProjetoLayoutRouteWithChildren,
    AppDashboardProjetosIndexRoute: AppDashboardProjetosIndexRoute,
  }

const AppDashboardProjetosLayoutRouteWithChildren =
  AppDashboardProjetosLayoutRoute._addFileChildren(
    AppDashboardProjetosLayoutRouteChildren,
  )

interface AppDashboardLayoutRouteChildren {
  AppDashboardProjetosLayoutRoute: typeof AppDashboardProjetosLayoutRouteWithChildren
  AppDashboardCentralRoute: typeof AppDashboardCentralRoute
  AppDashboardExplorarRoute: typeof AppDashboardExplorarRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
}

const AppDashboardLayoutRouteChildren: AppDashboardLayoutRouteChildren = {
  AppDashboardProjetosLayoutRoute: AppDashboardProjetosLayoutRouteWithChildren,
  AppDashboardCentralRoute: AppDashboardCentralRoute,
  AppDashboardExplorarRoute: AppDashboardExplorarRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
}

const AppDashboardLayoutRouteWithChildren =
  AppDashboardLayoutRoute._addFileChildren(AppDashboardLayoutRouteChildren)

interface AppStudioIdLayoutRouteChildren {
  AppStudioIdPublicarRoute: typeof AppStudioIdPublicarRoute
  AppStudioIdIndexRoute: typeof AppStudioIdIndexRoute
}

const AppStudioIdLayoutRouteChildren: AppStudioIdLayoutRouteChildren = {
  AppStudioIdPublicarRoute: AppStudioIdPublicarRoute,
  AppStudioIdIndexRoute: AppStudioIdIndexRoute,
}

const AppStudioIdLayoutRouteWithChildren =
  AppStudioIdLayoutRoute._addFileChildren(AppStudioIdLayoutRouteChildren)

interface AppLayoutRouteChildren {
  AppDashboardLayoutRoute: typeof AppDashboardLayoutRouteWithChildren
  AppStudioIdLayoutRoute: typeof AppStudioIdLayoutRouteWithChildren
}

const AppLayoutRouteChildren: AppLayoutRouteChildren = {
  AppDashboardLayoutRoute: AppDashboardLayoutRouteWithChildren,
  AppStudioIdLayoutRoute: AppStudioIdLayoutRouteWithChildren,
}

const AppLayoutRouteWithChildren = AppLayoutRoute._addFileChildren(
  AppLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppLayoutRoute: AppLayoutRouteWithChildren,
  AuthAuthRoute: AuthAuthRoute,
  AuthEntrarRoute: AuthEntrarRoute,
  AuthSairRoute: AuthSairRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
